import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";

import { ModalDialog, ModalService } from "../modal";
import { Button } from "../button/Button";
import { generateDeeplink } from "../deeplinkDialog/deeplinkDialog.actions";

import "./SpsonReminderDialog.scss";
import {
  checkLoadingStateAndShowRemoteDialog,
  hideRemoteReminderDialog,
} from "../../store/reminder/reminder.actions";
import { areAllHomePageDevicesLoaded } from "../../store/devices/devices.selectors";

export const SpsonReminderDialog = ({ modal }) => {
  const dispatch = useDispatch();

  const close = () => modal.reject();
  const nextModal = () => {
    dispatch(generateDeeplink(), { showLoader: false });
    return modal.resolve();
  };

  return (
    <ModalDialog
      submitHandler={nextModal}
      rejectHandler={close}
      className="spson-reminder"
    >
      <ModalDialog.Header>
        <h2 id="spson_reminder_title">
          <FormattedMessage id="spson_reminder_title" />
        </h2>
      </ModalDialog.Header>
      <ModalDialog.Body>
        <FormattedMessage id="spson_reminder_description" />
      </ModalDialog.Body>
      <ModalDialog.Footer>
        <Button size={"large"} onClick={close} color={"secondary"}>
          <FormattedMessage id="remind_later" />
        </Button>
        <Button size={"large"} onClick={nextModal}>
          <FormattedMessage id="activate_now" />
        </Button>
      </ModalDialog.Footer>
    </ModalDialog>
  );
};

export const useShowRemoteReminderDialog = () => {
  const dispatch = useDispatch();
  const loadingStatus = useSelector(areAllHomePageDevicesLoaded);

  useEffect(() => {
    dispatch(checkLoadingStateAndShowRemoteDialog());
  }, [dispatch, loadingStatus]);
};

export const openReminderDialog = () => (dispatch) => {
  ModalService.show((modal) => ({
    dialog: <SpsonReminderDialog modal={modal} />,
  }))
    .then(() => dispatch(hideRemoteReminderDialog()))
    .catch(() => dispatch(hideRemoteReminderDialog()));
};
